module.exports = __webpack_public_path__ + "static/media/Red.448b89aa.svg";